module.exports = __webpack_public_path__ + "img/ai.930945ca.png";